/**
 * @module  Experience/ProductSelector
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const PRODUCT_SELECTOR_CONSTANTS = {
  NAV_BROWSE_SERVICES: '/browse-services',
  NA: 'N/A',
  ADDALINE: 'ADDALINE',
  PLAN_FIRST: 'PLAN_FIRST',
  BYOD_FIRST: 'BYOD_FIRST',
  DEVICE_FIRST: 'DEVICE_FIRST',
  DEFAULT_INDEX: '1',
  SELECTED: 'selected',
  NICKNAME: 'NickName',
  DEFAULT: 'DEFAULT',
  NAV_CART_REVIEW: '/cart/review',
  BILLING_TYPE: 'PREPAID',
  BROWSE_ACCESSORIES: '/browse-accessories',
  DEVICE: 'DEVICE',
  SIM: 'SIM',
  HANDSET: 'HANDSET',
  MOBILE_INTERNET: 'MOBILEINTERNET',
  TABLET: 'TABLET',
  ACCESSORIES: 'accessories',
  DEVICES: 'devices',
  ZIP: '98007',
  ACTIVATION: 'ACTIVATION',
  CPS: 'CPS',
  BRING_YOUR_OWN_DEVICE_REQUEST_URL: '/bring-your-own-device',
  AUDIT_NICKNAME: 'LINE_NICK_NAME',
  COLON: ':',
  SHOP_FOR_A_DEVICE: 'shopForADevice',
  BRING_YOUR_OWN_DEVICE: 'bringYourOwnDevice',
  VOUCHER: 'Voucher',
  MISCELLANEOUS_FAMILY: 'Miscellaneous Services',
  INTERNATIONAL_FAMILY: 'International Services',
};

export const PRODUCT_SELECTOR_MODULE_COMPONENTS = {
  PRODUCT_SELECTOR_MODULE_NAME: 'ProductSelectorModule',
  PRODUCT_SELECTOR_SERVICE: 'ProductSelectorService',
};

export const DEFAULT_MAX_INDEX = 3;

export const PRODUCT_SELECTOR_ROUTES = {
  HTTP_URL: 'http(s?)://',
  CART: '/cart',
  PRODUCT_SELECTOR: '/product-selector',
  ACCOUNT_LANDING: '/account-landing',
  HOME: '/home',
};
